import React from 'react'
import { Row, Col, Form, Button, OverlayTrigger, Tooltip, Table, Badge } from 'react-bootstrap'

const Reports = () => (
    <>
      <h1>Relacion de entrega de documentos</h1>
      <hr />
      <Row>
        <Col
          xs="12"
        >
        <Form>
          <Row>
            <Col md="4">
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label>Carrera</Form.Label>
                <Form.Control as="select" custom>
                  <option>Seleccionar</option>
                  <option>Sistemas de informacion</option>
                  <option>Mecatrónica</option>
                  <option>Aeronautica</option>
                  <option>Industrial</option>
                  <option>Civil</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group controlId="exampleForm.SelectCustom">
                <Form.Label>Estatus</Form.Label>
                <Form.Control as="select" custom>
                  <option>Seleccionar</option>
                  <option>Aprobado</option>
                  <option>Tardia</option>
                  <option>Baja</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="2" className="mt-4">
              <Button>
                Buscar
              </Button>
            </Col>
            <Col md="2" className="mt-4">
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Exportar PDF</Tooltip>}>
                <span className="d-inline-block">
                  <Button variant="outline-dark">
                    <i className="fa fa-file-pdf-o"/>
                  </Button>
                </span>
              </OverlayTrigger>
              {" "}
              <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Exportar Excel</Tooltip>}>
                <span className="d-inline-block">
                  <Button variant="outline-dark">
                      <i className="fa fa-file-excel-o"/>
                  </Button>
                </span>
              </OverlayTrigger>
            </Col>
          </Row>
        </Form>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs="12">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Solicitud</th>
                <th>Carrera</th>
                <th>Alumno</th>
                <th>CURP</th>
                <th>Fecha de inscripci&oacute;n</th>
                <th>Estatus</th>
                <th>Acci&oacute;n</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1060</td>
                <td>INGENIERIA MECANICA</td>
                <td>MARIA ELENA ACUÑA VILLANUEVA</td>
                <td>AUVE010522MSRCLLA1</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="success">
                    Inscrito
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>111</td>
                <td>INGENIERIA MECANICA</td>
                <td>MIGUEL ANGEL ALCANTARA LEAL</td>
                <td>AALM011101HSLLLGA7</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="danger">
                    Baja
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>4025</td>
                <td>INGENIERIA MECANICA</td>
                <td>MANUEL ENRIQUE ALVAREZ MONTIJO</td>
                <td>AAMM971027HSRLNN03</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="info">
                      Tardia
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>1060</td>
                <td>INGENIERIA MECANICA</td>
                <td>MARIA ELENA ACUÑA VILLANUEVA</td>
                <td>AUVE010522MSRCLLA1</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="success">
                      Inscrito
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>111</td>
                <td>INGENIERIA MECANICA</td>
                <td>MIGUEL ANGEL ALCANTARA LEAL</td>
                <td>AALM011101HSLLLGA7</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="danger">
                      Baja
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>4025</td>
                <td>INGENIERIA MECANICA</td>
                <td>MANUEL ENRIQUE ALVAREZ MONTIJO</td>
                <td>AAMM971027HSRLNN03</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="info">
                      Tardia
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>1060</td>
                <td>INGENIERIA MECANICA</td>
                <td>MARIA ELENA ACUÑA VILLANUEVA</td>
                <td>AUVE010522MSRCLLA1</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="success">
                    Inscrito
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>111</td>
                <td>INGENIERIA MECANICA</td>
                <td>MIGUEL ANGEL ALCANTARA LEAL</td>
                <td>AALM011101HSLLLGA7</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="danger">
                      Baja
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>4025</td>
                <td>INGENIERIA MECANICA</td>
                <td>MANUEL ENRIQUE ALVAREZ MONTIJO</td>
                <td>AAMM971027HSRLNN03</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="info">
                      Tardia
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>1060</td>
                <td>INGENIERIA MECANICA</td>
                <td>MARIA ELENA ACUÑA VILLANUEVA</td>
                <td>AUVE010522MSRCLLA1</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="success">
                      Inscrito
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>111</td>
                <td>INGENIERIA MECANICA</td>
                <td>MIGUEL ANGEL ALCANTARA LEAL</td>
                <td>AALM011101HSLLLGA7</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="danger">
                      Baja
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td>4025</td>
                <td>INGENIERIA MECANICA</td>
                <td>MANUEL ENRIQUE ALVAREZ MONTIJO</td>
                <td>AAMM971027HSRLNN03</td>
                <td>2019-08-07 8:00:00.0</td>
                <td>
                  <Badge pill variant="info">
                      Tardia
                  </Badge>
                </td>
                <td>
                  <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Detalles</Tooltip>}>
                    <span className="d-inline-block">
                      <Button variant="primary" size="sm">
                        <i className="fa fa-edit"/>
                      </Button>
                    </span>
                  </OverlayTrigger>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
)

export default Reports